<template>
  <div>
    <van-nav-bar :title="barTitle" :left-text="leftText" @click-left="onClickLeft" />
    <van-form ref="form" @submit="save">
      <van-tabs v-model="active">
        <van-tab title="基础信息">
          <base-input v-model="form.type_name" label='发票类型' disabled />
          <base-input v-model="form.payer" label='抬头名称' disabled />
          <base-input v-model="form.taxpayer_code" label='纳税人识别号' disabled />
          <base-input v-model="form.addr_phone" label='地址、电话' :rules="[{ required: false, message: '请填写地址、电话' }]" placeholder=" " disabled />
          <base-input v-model="form.bank_account" label='开户行及账号' :rules="[{ required: false, message: '请填写开户行及账号' }]" placeholder=" " disabled />
          <base-input v-model="form.mobile" label='短信手机号' disabled />
          <base-input v-model="form.handover_type_name" label='交接方式' disabled />
          <base-input v-model="form.handover_remark" label='运单号或邮箱' :rules="[{ required: false, message: '请填写运单号或邮箱' }]" placeholder=" " />
          <base-input v-model="form.address" label='收件人地址' :rules="[{ required: false, message: '请填写收件人地址' }]" placeholder=" " disabled />
          <base-input v-model="form.comment" label='备注' :rules="[{ required: false, message: '请填写备注' }]" placeholder=" " disabled />
          <base-select v-model="form.status" :options="statusList" :required="true" label='状态' placeholder=" " disabled />
          <base-input v-model="form.inv_num" label='发票号' :required="true" />
        </van-tab>
        <van-tab title="发票明细">
          <van-row class="list-title">
            <van-col span="4">货物或应税劳务名称</van-col>
            <van-col span="4">规格型号</van-col>
            <van-col span="4">单位</van-col>
            <van-col span="4">数量</van-col>
            <van-col span="4">单价</van-col>
            <van-col span="4">金额</van-col>
          </van-row>
          <van-cell v-for="detail in form.details" :key="detail.id" class="list-tip" >
            <van-col span="4" style="text-align: center">
              <base-input :type="'date'" v-model="detail.item" />
            </van-col>
            <van-col span="4" style="text-align: center">
              <base-input v-model="detail.specification" />
            </van-col>
            <van-col span="4" style="text-align: center">
              <base-input v-model="detail.unit" />
            </van-col>
            <van-col span="4" style="text-align: center">
              <base-input-number v-model="detail.count" />
            </van-col>
            <van-col span="4" style="text-align: center">
              <base-input-number v-model="detail.price" />
            </van-col>
            <van-col span="4" style="text-align: center">
              <base-input-number v-model="detail.amount" />
            </van-col>
          </van-cell>
        </van-tab>
      </van-tabs>
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">修改发票状态</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import { modifyInvoiceStatus } from '@/api/invoice'
export default {
  name: 'InvoiceEdit',
  data() {
    return {
      barTitle: '发票信息',
      leftText: '',
      active: 0,
      data: [],
      detailsMap: [],
      statusList: [],

      queryCondition: {
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS
      },
      form: {
        id: null,
        type_name: '',
        payer: '',
        taxpayer_code: '',
        addr_phone: '',
        bank_account: '',
        mobile: '',
        handover_type: null,
        handover_type_name: '',
        handover_remark: '',
        address: '',
        comment: '',
        status: null,
        inv_num: '',
        details: []
      }
    }
  },
  computed: {
    ...mapGetters(['selectedInvoice'])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.resetForm();
      if (this.selectedInvoice) {
        this.barTitle = '发票信息'
        this.leftText = '返回'
        if (!this.selectedInvoice.details) {
          this.selectedInvoice.details = [];
        }
        const data = this._.cloneDeep(this.selectedInvoice)
        if (data.type === 1 && data.status  === 1) {
          this.statusList = this.CONST.INVOICE_STATUS2;
        } else {
          this.statusList = this.CONST.INVOICE_STATUS;
        }
        data.details = data.details ? data.details : []
        data.details.forEach(item => {
          this.detailsMap[item.id] = item.comment
        })
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
          overlay: true
        })
        setTimeout(() => {
          this.form = data;
          Toast.clear()
        }, 1000)
      }
    },
    resetForm() {
      this.Utils.resetValue(this.form);
    },
    onClickLeft() {
      this.$router.push('/invoice/manage')
    },
    save() {
      if (this.form.status === 1) {
        this.toast('状态禁止修改为待开票');
        return;
      }
      if (this.form.handover_type === 2 && !this.form.handover_remark) {
        this.toast('请填写运单号');
        return;
      }
      if (this.form.handover_type === 3 && !this.form.handover_remark) {
        this.toast('请填写邮箱');
        return;
      }
      const status_name = this.CONST.INVOICE_STATUS.find(item => item.id === this.form.status).name;
      modifyInvoiceStatus({
        id: this.form.id,
        client_name: this.form.client_name,
        payer: this.form.payer,
        status: this.form.status,
        status_name: status_name,
        mobile: this.form.mobile,
        inv_num: this.form.inv_num,
        handover_type: this.form.handover_type,
        handover_remark: this.form.handover_remark,
        create_time: this.form.create_time
      }).then(resp => {
        if (resp.success) {
          this.success(resp.msg);
          this.$router.push('/invoice/manage');
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoice/invoice-edit.vue